
import * as Msdyn365 from '@msdyn365-commerce/core';
import {getSelectedProductIdFromActionInput } from '@msdyn365-commerce-modules/retail-actions';
import { getProductsSalesAgreementAsync } from './getProductsSalesAgreement';
import { IGCProductTradeAgreementsEntity } from './AlternateItemsEntity.g';

export class HSGetProductTradeAgreementsInput implements Msdyn365.IActionInput {
    public productId: number;

    public channelId: number;

    public config: any;

    constructor(productId: number, channelId: number, config: any) {
        this.channelId = channelId;
        this.productId = productId;
        this.config = config;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `HSGetProductTradeAgreements${this.productId}`;
    public getCacheObjectType = () => 'ProductTradeAgreements';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

const createInput = (inputData: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    const productId = getSelectedProductIdFromActionInput(inputData);
    if(productId)
    {
        return new HSGetProductTradeAgreementsInput(+productId, +inputData.requestContext.apiSettings.channelId, inputData.config);

    }
    throw new Error('Unable to create SelectedVariantInput, no productId found on module config or query');
};


async function action(input: HSGetProductTradeAgreementsInput, ctx: Msdyn365.IActionContext): Promise<IGCProductTradeAgreementsEntity[] | undefined> {
    const prodRecId:number[] =[];
    prodRecId.push(input.productId);
  const productTradeAgreements = await getProductsSalesAgreementAsync({callerContext: ctx},prodRecId);
  if(productTradeAgreements)
  {
      return productTradeAgreements.gcProductTradeAgreementsEntity;
  }

  return undefined;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGCProductTradeAgreementsEntity[]>>action,
    // TODO: Give your data action a unique id
    id: 'HSGetProductTradeAgreementsAction',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
